module.exports = __webpack_public_path__ + "./fonts/Ubuntu-Regular.ttf";